import { useState } from 'react';
import clsx from 'clsx';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { FormTemplateInfo } from '@atom/types/form';

import classes from './addFormsModal.module.css';

interface Props {
  formTemplate: FormTemplateInfo;
  subtext?: string;
  isSelected: boolean;
  availableForms: Set<string>;
  toggleFormSelect: (id: string) => void;
}

const FormRow = ({
  formTemplate,
  subtext,
  isSelected,
  toggleFormSelect,
  availableForms,
}: Props) => {
  const [selected, setSelected] = useState<boolean>(isSelected);

  const isAvailable = availableForms.has(formTemplate.id);

  const toggleForm = () => {
    toggleFormSelect(formTemplate.id);
    setSelected(!selected);
  };

  const nameStyle = (): string => {
    return clsx(
      classes.formRowTitle,
      selected && classes.selected,
      !isAvailable && classes.disabled,
    );
  };

  const subtextStyle = clsx(
    classes.titleSubtext,
    !isAvailable && classes.disabled,
  );
  const buttonIcon = selected ? 'check' : 'add';
  const iconStyle = {
    color: selected ? colors.brand.blue : colors.neutral.gray,
    cursor: 'pointer',
  };
  const iconColor = isAvailable ? colors.brand.blue : colors.neutral.silver;

  return (
    <div className={classes.formRow}>
      <div className={classes.formTitleContainer}>
        <Icon color={iconColor}>library_books</Icon>
        <div className={classes.formTitleContent}>
          <div className={nameStyle()}>{formTemplate.name}</div>
          <div className={subtextStyle}>{subtext}</div>
        </div>
      </div>
      {isAvailable && (
        <Icon style={iconStyle} onClick={toggleForm}>
          {buttonIcon}
        </Icon>
      )}
    </div>
  );
};

export default FormRow;
